export const FETCH_YELLOWFIN_SSO_TOKEN = "yellowfin/FETCH_YELLOWFIN_SSO_TOKEN";



// WEBPACK FOOTER //
// ./src/features/yellowfin/action-types.js